import * as React from 'react';

const SvgRotateRight = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
    <svg viewBox="0 0 22.18 19.08">
        <path d="M10,0A9.55,9.55,0,0,0,0,9.1c0,0.15,0,.3,0,0.45a9.54,9.54,0,0,0,15.3,7.6,0.5,0.5,0,0,0-.6-0.8A8.54,8.54,0,0,1,3.23,15.29,8.46,8.46,0,0,1,1,9.15a8.54,8.54,0,0,1,17.06-.08l-3.2-2.7a0.5,0.5,0,0,0-.7.06,0.49,0.49,0,0,0-.12.32,0.51,0.51,0,0,0,.18.38l4,3.37a0.51,0.51,0,0,0,.38.11,0.5,0.5,0,0,0,.34-0.2l3.14-4.19a0.5,0.5,0,1,0-.8-0.6L19,8.64A9.56,9.56,0,0,0,10,0Z" style="fill:#cdcccc"/>
    </svg>
);

export default SvgRotateRight;
